/* Vemica Blog Hub - category chip filtering across every blog.

   WHY CLIENT-SIDE
   The hub pools articles from all blogs, and Liquid cannot read arbitrary query
   params (there is no request.query_string), so a server-rendered ?tag= route is
   impossible. Shopify's own /blogs/<handle>/tagged/<tag> pages are scoped to a
   single blog - exactly the limitation being fixed. Each pooled article is
   rendered once carrying its blog handle and tags, and chips filter that set, so
   results span all blogs and an article can never appear twice.

   WHY BLOG *AND* TAG
   Measured on this store: 47 of 48 articles have an empty tags array, so tags
   alone would leave every chip empty. The blogs (pickle, masala, coffee, tea,
   honey) are the real taxonomy. A chip therefore matches when the card's blog is
   in the chip's blog list OR the card carries the chip's tag - so "Coffee & Tea"
   can span two blogs, and thematic chips like "Recipes" work off tags as soon as
   articles are tagged.

   Progressive enhancement: without JS the chips stay real links to Shopify's
   native per-blog tag pages and CSS shows only the designed number of cards.
   Adding .hub-ready hands visibility control to this script.

   State lives in location.hash so a filtered view is shareable and survives
   reload and the back button. */
(function () {
  var grid = document.querySelector('[data-hub-grid]');
  if (!grid) return;

  var cards = [].slice.call(grid.querySelectorAll('[data-tags]'));
  var chips = [].slice.call(document.querySelectorAll('[data-hub-key]'));
  var empty = document.querySelector('[data-hub-empty]');
  var heading = document.querySelector('[data-hub-heading]');
  var baseHeading = heading ? heading.textContent : '';
  var defaultCount = parseInt(grid.getAttribute('data-default-count'), 10) || 6;

  function norm(s) {
    return (s || '').toString().toLowerCase().trim();
  }

  function listOf(el, attr) {
    return norm(el.getAttribute(attr))
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);
  }

  function chipByKey(key) {
    var found = null;
    chips.forEach(function (chip) {
      if (norm(chip.getAttribute('data-hub-key')) === key) found = chip;
    });
    return found;
  }

  function matches(card, chip) {
    var wantTag = norm(chip.getAttribute('data-hub-tag'));
    var wantBlogs = listOf(chip, 'data-hub-blogs');
    // A chip with neither is the "All" chip.
    if (!wantTag && !wantBlogs.length) return true;
    if (wantBlogs.indexOf(norm(card.getAttribute('data-blog'))) > -1) return true;
    return wantTag ? listOf(card, 'data-tags').indexOf(wantTag) > -1 : false;
  }

  function apply(key) {
    var want = norm(key);
    var chip = want ? chipByKey(want) : null;
    if (want && !chip) want = '';

    var shown = 0;
    cards.forEach(function (card) {
      var hit = chip ? matches(card, chip) : true;
      // Unfiltered, keep the designed grid length; filtered, show every hit.
      var visible = hit && (chip ? true : shown < defaultCount);
      if (visible) shown++;
      card.classList.toggle('is-hidden', !visible);
    });

    if (empty) empty.hidden = shown > 0;

    chips.forEach(function (c) {
      var on = c === chip || (!chip && !norm(c.getAttribute('data-hub-tag')) && !listOf(c, 'data-hub-blogs').length);
      c.classList.toggle('is-on', on);
      if (on) {
        c.setAttribute('aria-current', 'true');
      } else {
        c.removeAttribute('aria-current');
      }
    });

    if (heading && baseHeading) {
      var label = chip ? (chip.textContent || '').trim() : '';
      heading.textContent = label ? baseHeading + ' — ' + label : baseHeading;
    }
  }

  function readHash() {
    var raw = (location.hash || '').replace(/^#/, '');
    try {
      return decodeURIComponent(raw);
    } catch (e) {
      return raw;
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function (event) {
      event.preventDefault();
      var key = chip.getAttribute('data-hub-key') || '';
      var isAll = !norm(chip.getAttribute('data-hub-tag')) && !listOf(chip, 'data-hub-blogs').length;
      try {
        if (isAll) {
          history.replaceState(null, '', location.pathname);
        } else {
          history.replaceState(null, '', '#' + encodeURIComponent(key));
        }
      } catch (e) {
        /* history can be unavailable in embedded contexts - filtering still works */
      }
      apply(isAll ? '' : key);
      grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  window.addEventListener('hashchange', function () {
    apply(readHash());
  });

  grid.classList.add('hub-ready');
  apply(readHash());
})();
